import request from '../adminRequest'
export const practiceQuestionApi = {
  listPracticeQuestion (params) {
    return request.get('/practiceQuestions', { params: params })
  },
  getPracticeQuestion (id) {
    return request.get('/practiceQuestions/' + id)
  },
  savePracticeQuestion (data) {
    return request.post('/practiceQuestions', data)
  },
  updatePracticeQuestion (id, data) {
    return request.put('/practiceQuestions/' + id, data)
  },
  deletePracticeQuestion (id) {
    return request.delete('/practiceQuestions/' + id)
  },
  publishAll (data) {
    return request.put('/practiceQuestions/', data)
  },
}

export default practiceQuestionApi
